import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";

const IconeOlhoAberto = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
  </svg>
);

const IconeOlhoFechado = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
  </svg>
);

/**
 * Senha — campo de senha com toggle de visibilidade (olhinho).
 *
 * Props aceitas (idênticas ao Form.Control do Bootstrap):
 *   value, onChange, placeholder, disabled, id, name, isInvalid, isValid, size
 *   label    — rótulo exibido acima (opcional)
 *   helpText — texto de ajuda abaixo (opcional)
 */
function Senha({
  value = "",
  onChange,
  placeholder = "••••••••",
  disabled = false,
  id,
  name,
  isInvalid,
  isValid,
  size,
  label,
  helpText,
  className = "",
  style,
}) {
  const [visivel, setVisivel] = useState(false);

  return (
    <Form.Group className={className} style={style}>
      {label && <Form.Label>{label}</Form.Label>}

      <InputGroup>
        <Form.Control
          id={id}
          name={name}
          type={visivel ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          isInvalid={isInvalid}
          isValid={isValid}
          size={size}
          style={{ borderRight: "none" }}
          autoComplete="new-password"
        />

        <InputGroup.Text
          onClick={() => !disabled && setVisivel((v) => !v)}
          title={visivel ? "Ocultar senha" : "Exibir senha"}
          style={{
            cursor: disabled ? "default" : "pointer",
            background: "#fff",
            border: "1px solid #ced4da",
            borderLeft: "none",
            borderRadius: "0 0.375rem 0.375rem 0",
            color: visivel ? "#0d6efd" : "#6c757d",
            transition: "color 0.15s",
            userSelect: "none",
            padding: "0 0.75rem",
          }}
          onMouseEnter={(e) => {
            if (!disabled) e.currentTarget.style.color = "#0d6efd";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = visivel ? "#0d6efd" : "#6c757d";
          }}
        >
          {visivel ? <IconeOlhoFechado /> : <IconeOlhoAberto />}
        </InputGroup.Text>

        {isInvalid && (
          <Form.Control.Feedback type="invalid">
            Campo obrigatório.
          </Form.Control.Feedback>
        )}
      </InputGroup>

      {helpText && (
        <Form.Text className="text-muted" style={{ fontSize: "0.78rem" }}>
          {helpText}
        </Form.Text>
      )}
    </Form.Group>
  );
}

export default Senha;
